import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export enum ListPanelVariants {
  Open = 'open',
  Closed = 'closed',
}

const PANEL_WIDTH = '22rem'

const ListPanelParts = ['staticContainer', 'slidingContainer'] as const

const helpers = createMultiStyleConfigHelpers(ListPanelParts)

export const ListPanelStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    staticContainer: {
      flexDirection: 'column',
      flexShrink: 0,
      alignItems: 'flex-start',
      width: PANEL_WIDTH,
      height: 'full',
      backgroundColor: 'bg.default',
      borderRight: '0 solid',
    },
    slidingContainer: {
      flexDirection: 'column',
      shrink: 0,
      alignItems: 'flex-start',
      width: PANEL_WIDTH,
      minWidth: 0,
      height: 'full',
      backgroundColor: 'bg.default',
      zIndex: 3,
      transition: 'all 0.25s ease-in-out',
      borderRight: '2px solid',
      borderColor: 'border.default',
    },
  },
  variants: {
    [ListPanelVariants.Open]: {
      slidingContainer: {
        left: 0,
        boxShadow: `.25rem 0 1rem 0 rgba(0,0,0,.15)`,
      },
    },
    [ListPanelVariants.Closed]: {
      slidingContainer: {
        left: `-${PANEL_WIDTH}`,
        borderRight: '0 solid',
      },
    },
  },
  defaultProps: {
    variant: ListPanelVariants.Open,
  },
})

export const useListPanelStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ListPanelStyle, props) as MultiStyleType<
    typeof ListPanelParts
  >
}
